import { opportunityFetch } from "./opportunityFetch";
import type { OpportunityFormatKey } from "@/types/opportunity";
import type {
  ProposalPage,
  ProposalPageArchetype,
  ProposalPageBody,
} from "./proposalPageTypes";

export type ListProposalPagesFilters = {
  format_key: OpportunityFormatKey;
  product_type: string;
  archetype?: ProposalPageArchetype;
  /** When true (default), seed primary pages if missing. */
  ensure?: boolean;
};

export function listProposalPages(filters: ListProposalPagesFilters) {
  const q = new URLSearchParams();
  q.set("format_key", filters.format_key);
  q.set("product_type", filters.product_type);
  if (filters.archetype) q.set("archetype", filters.archetype);
  if (filters.ensure === false) q.set("ensure", "0");
  return opportunityFetch<{
    ok: true;
    pages: ProposalPage[];
    pages_supported?: boolean;
    error?: string;
  }>(`/api/opportunity/proposal-page-list?${q.toString()}`, { method: "GET" });
}

export type UpsertProposalPagePayload = {
  format_key: OpportunityFormatKey;
  product_type: string;
  page_key: string;
  label: string;
  archetype: ProposalPageArchetype;
  body: ProposalPageBody;
  sort_order?: number;
};

export function upsertProposalPage(payload: UpsertProposalPagePayload) {
  return opportunityFetch<{ ok: true; page: ProposalPage }>(
    "/api/opportunity/proposal-page-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function deleteProposalPage(args: {
  format_key: OpportunityFormatKey;
  product_type: string;
  page_key: string;
}) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/proposal-page-delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(args),
  });
}
